/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { ReactSVG } from "react-svg";
import {
    getAnswers,
    quizInteractionTracking,
} from "../../QuizHelpers/index.js";
import { useQuiz } from "src/contexts/QuizContext.js";

import pencilIcon from "src/files/pencil.svg";

const QuizConfirmAnswers = ({ _question }) => {
    const { dispatch } = useQuiz();
    const answers = getAnswers(_question);
    const questionNumber = `Q${_question.id}`;

    const [mediaWidth, setMediaWidth] = useState(0);
    const [respHeight, setRespHeight] = useState(0);

    const respCont = useRef(null);

    const calculateRespHeight = useCallback(() => {
        if (respCont.current) {
            setRespHeight(respCont.current.offsetHeight);
            setMediaWidth(window.innerWidth);
        }
    }, [respCont.current]);

    useEffect(() => {
        calculateRespHeight();
    }, [respCont.current]);

    return answers.length ? (
        <div
            className="quiz-question__header-responses responses--complete"
            ref={respCont}
            style={
                answers.length <= 4 && mediaWidth > 1024
                    ? {
                          paddingTop: "180px",
                          paddingBottom: "180px",
                      }
                    : answers.length > 4 &&
                        respHeight < 900 &&
                        mediaWidth > 1024
                      ? {
                            height: `calc(${respHeight}px - 10%)`,
                            paddingTop: "580px",
                            paddingBottom: "160px",
                        }
                      : answers.length > 4 &&
                          respHeight >= 900 &&
                          mediaWidth > 1024
                        ? {
                              height: `calc(${respHeight}px - 2%)`,
                              paddingTop: "220px",
                              paddingBottom: "100px",
                          }
                        : {}
            }
        >
            {answers.map((answer, index) => {
                const {
                    title,
                    questionNo,
                    questionSection,
                    savedAnswer,
                    savedAnswerIndex,
                } = answer;

                return (
                    <div
                        key={index}
                        className={`quiz-question__header-responses-item ${savedAnswer ? `user--saved` : `user--pending`}`}
                    >
                        {title && (
                            <h4 className="quiz-question__header-response-q">
                                {title}
                            </h4>
                        )}
                        {/* Selected Input */}
                        <div className="quiz-question__options-selected">
                            {/* Display savedAnswer or currentAnswer */}
                            <p className="quiz-question__options-selected-input">
                                {savedAnswer}
                            </p>
                            {/* Edit button to change savedAnswer or currentAnswer */}
                            <button
                                className="quiz-question__options-edit-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    dispatch({
                                        type: "editAnswer",
                                        payload: { ...answer },
                                    });
                                    quizInteractionTracking({
                                        event: "quiz_interaction",
                                        interaction_type: "click",
                                        question_number: questionNo,
                                        sub_question_index: questionSection,
                                        selected_answer_index: savedAnswerIndex, //previous selection
                                        answer_changed: false,
                                        navigation_action: "change",
                                    });
                                }}
                            >
                                <ReactSVG src={pencilIcon}></ReactSVG>
                                <span>Change</span>
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    ) : (
        <></>
    );
};

export default QuizConfirmAnswers;
